import { api } from '../lib/api'
import { getConfig } from '../lib/config'

export function addPhotoSize(url: string, size: number): string {
  if (!url) return url

  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}size=${size}`
}

/**
 * Absolute URL for a photo serve endpoint.
 *
 * Prefer {@link fetchPhotoObjectUrl} for browser <img> tags: photo serve
 * requires a Bearer token, which img src cannot send.
 */
export function getPhotoUrl(photoId: string, size?: number): string {
  if (!photoId) return ''

  // If photoId is already a full URL, return it as-is (useful for stories/testing)
  if (photoId.startsWith('http://') || photoId.startsWith('https://')) {
    return photoId
  }

  // Authenticated serve goes through the API host (static host is the same service
  // in production but may not share cookie/CORS expectations in all setups).
  const apiUrl = getConfig().apiUrl.replace(/\/$/, '')
  const url = `${apiUrl}/photos/${photoId}/serve`

  if (size !== undefined) {
    return addPhotoSize(url, size)
  }

  return url
}

/**
 * Fetches a photo with the member Authorization header and returns a blob:
 * object URL suitable for <img src>. Caller must revoke the URL when done
 * (except when the return value is an absolute http(s) URL).
 */
export async function fetchPhotoObjectUrl(photoId: string, size?: number): Promise<string | null> {
  if (!photoId) return null

  if (photoId.startsWith('http://') || photoId.startsWith('https://')) {
    return photoId
  }

  const path =
    size !== undefined ? `/photos/${photoId}/serve?size=${size}` : `/photos/${photoId}/serve`

  try {
    const response = await api.fetch(path)
    if (!response.ok) return null
    const blob = await response.blob()
    return URL.createObjectURL(blob)
  } catch {
    return null
  }
}

export function revokePhotoObjectUrl(url: string | null | undefined) {
  if (url && url.startsWith('blob:')) URL.revokeObjectURL(url)
}
